<style scoped>
.validation-notice {
    display: inline-block;
    background: #eeeeee;
    border-radius: 4px;
    padding: 4px 8px;
    margin-bottom: 5px;
    font-size: 0.8em;
}
</style>
<template>
    <div class="form-group clearfix no-focus" :class="[settings.isChild ? 'form-group-child' : null, colClass]" :style="adminPreview && settings.serverSide ? 'display:flex' : ''">
        <ErrorList :data="data" :id="errorId" />
        <AdminSettingsDifferences :data="data" />
        <HelpIcon class="d-inline-flex ml-1" iconClass="icon-warning" v-if="adminPreview && settings.serverSide && !valid" text="Validation on Section Change or Submit setting is ignored in Preview." />
    </div>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import HelpIcon from "@/lib/HelpIcon.3.vue";
import { usePageStore } from "../pageState/store";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import { useObservable } from "@vueuse/rxjs";
import type ValidationDef from "../elements/ValidationDef";
import type { ValidationSettings } from "@cs-ts/validation-settings";
export default defineComponent({
    components: {
        ...components,
        HelpIcon,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<ValidationDef, ValidationSettings>) {
        const base = setup<ValidationDef, ValidationSettings>(props);

        const pageStore = usePageStore();
        const adminPreview = computed(() => pageStore.adminPreview);

        const valid = useObservable(props.data.valid$());

        return {
            adminPreview,
            valid,

            ...base.expose,
        };
    },
});
</script>
